import type { IManagementCardProps } from "app/pages/sales-intelligence/modules/manage-integrations/components/cards-components/ManagementCard";
import {
    MANAGE_INTEGRATIONS_CARD_SYNCED,
    MANAGE_INTEGRATIONS_CARD_SYNCING,
} from "app/pages/sales-intelligence/modules/manage-integrations/constants/translations";
import {
    INTEGRATION_STATUS,
    SYNC_FAILED_REASON_CODE_INSUFFICIENT_PERMISSIONS,
    TOOLTIP_TEXT_MAP,
} from "app/pages/sales-intelligence/pages/management/constants/constants";
import { SL_LIST_MANAGEMENT_SF_INTEGRATION_STATUS_FAILED } from "app/pages/sales-intelligence/pages/management/translations/salesforceKeys";
import type { Integration, IntegrationSyncStatus } from "app/pages/sales-intelligence/sub-modules/management/types";

type ChipState = Pick<IManagementCardProps, "chipType" | "chipText" | "isStatusInProgress" | "tooltipText">;

export const getChipState = (
    status: IntegrationSyncStatus,
    syncFailedReasonCode: number | undefined,
    integrationName: Integration,
    translate: (key: string) => string,
): ChipState => {
    if (status === INTEGRATION_STATUS.NotIntegrated) {
        return {};
    }

    const isInProgress = status === INTEGRATION_STATUS.InProgress || status === INTEGRATION_STATUS.New;

    if (isInProgress) {
        return {
            chipText: translate(MANAGE_INTEGRATIONS_CARD_SYNCING),
            chipType: "warning",
            isStatusInProgress: true,
            tooltipText: translate(TOOLTIP_TEXT_MAP.InProgress[integrationName]),
        };
    }

    if (status === INTEGRATION_STATUS.Failed) {
        const mainKey =
            syncFailedReasonCode === SYNC_FAILED_REASON_CODE_INSUFFICIENT_PERMISSIONS
                ? TOOLTIP_TEXT_MAP.FailedUnauthorized[integrationName]
                : TOOLTIP_TEXT_MAP.Failed[integrationName];

        return {
            chipText: translate(SL_LIST_MANAGEMENT_SF_INTEGRATION_STATUS_FAILED),
            chipType: "error",
            tooltipText: translate(mainKey),
        };
    }

    return {
        chipText: translate(MANAGE_INTEGRATIONS_CARD_SYNCED),
        chipType: "success",
    };
};
